export const INTRO_DURATION = 2.3;
export const HERO_BASE_DELAY = 2.5;

export const INTRO_PENDING =
  typeof window !== "undefined" &&
  !sessionStorage.getItem("snapx_intro") &&
  !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const markIntroDone = () => {
  try {
    sessionStorage.setItem("snapx_intro", "1");
  } catch {}
};
